import { render } from "./AlzataTextInput.vue?vue&type=template&id=2884c9ba"
import script from "./AlzataTextInput.vue?vue&type=script&lang=js"
export * from "./AlzataTextInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__